import { openBlock as e, createElementBlock as c, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M6.77 1.011a.75.75 0 0 0-1.342 0L.676 10.516a.75.75 0 0 0 .67 1.085H6.3v2.24c0 .863.7 1.562 1.562 1.562h5.979c.863 0 1.562-.7 1.562-1.562V7.862c0-.863-.7-1.562-1.562-1.562H9.414L6.77 1.01Zm.97 5.293-1.641-3.28L2.56 10.1H6.3V7.862c0-.822.634-1.495 1.44-1.558Zm.06 3.797V7.862c0-.034.028-.062.062-.062h.625l1.15 2.301H7.8Zm0 1.5h3.051a.75.75 0 0 0 .671-1.085L10.164 7.8h3.677c.034 0 .062.028.062.062v5.979a.063.063 0 0 1-.062.062H7.862a.063.063 0 0 1-.062-.062V11.6Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  l
];
function r(d, a) {
  return e(), c("svg", t, [...n]);
}
const s = { render: r };
export {
  s as default,
  r as render
};
